import { gql, TypedDocumentNode } from "@apollo/client";

import {
  FlowsProjectRoleBinding,
  MutationFlowsProjectRoleBindingBatchCreateArgs,
} from "types/generated";

type FlowsProjectRoleBindingBatchCreateData = {
  flowsProjectRoleBindingBatchCreate: Pick<FlowsProjectRoleBinding, "id">[];
};

export const FLOWS_PROJECT_ROLE_BINDING_BATCH_CREATE: TypedDocumentNode<
  FlowsProjectRoleBindingBatchCreateData,
  MutationFlowsProjectRoleBindingBatchCreateArgs
> = gql`
  mutation FlowsProjectRoleBindingBatchCreate($input: FlowsProjectRoleBindingBatchInput!) {
    flowsProjectRoleBindingBatchCreate(input: $input) {
      id
    }
  }
`;
